export default __webpack_public_path__ + "static/media/carousel-01-indumentaria-femenina.27a8dd62.png";